module.exports = "<nps-application-bar-layout>\n    <nps-pull-out-menu-layout>\n        <router-outlet></router-outlet>\n    </nps-pull-out-menu-layout>\n</nps-application-bar-layout>"


//////////////////
// WEBPACK FOOTER
// ./src/app/MainView/mainViewComponent.html
// module id = 1155
// module chunks = 0